module.exports = __webpack_public_path__ + "static/media/181CO107.95b88029.jpg";